<template>
  <ContentTemplate title="Slack" icon="integrations/slack.svg" step="1/1" :container-size-small="true">
    <div class="slack-step">
      <div class="slack-step-1">
        <h2>Configuration</h2>
        <form>
          <FormGroupSection
            v-for="(item, index) in slackForm"
            :key="index"
            :label="item.label"
            :icon="item.icon"
            :icon-type="item.iconType"
            :input="item.input"
            :description="item.description"
            v-model:input-value="form[item.input.name]"
            dropdown-value=""
          />
        </form>
      </div>
    </div>
  </ContentTemplate>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {ContentTemplate, FormGroupSection} from "@shared/components";
import {CommonNs} from "@shared/types";

export default defineComponent({
  name: 'SlackView',
  components: {
    ContentTemplate,
    FormGroupSection,
  },
  data() {
    return {
      form: {
        WebhookURL: '',
      },
      slackForm: [
        {
          label: 'Webhook URL',
          icon: 'Link',
          iconType: 'fal',
          description:
            'URL for the Slack incoming webhook. It should look something like this: https://featureplanner.slack.com/services/hooks/incoming-webhook?token=1234',
          input: {
            name: 'WebhookURL',
            type: 'text',
            placeholder: 'https://name.slack.com',
          },
        },
      ] as CommonNs.InputFormGroup[],
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        WebhookURL: { required },
      },
    };
  },
});
</script>

<style lang="scss">
.slack-step-1 {
  h2 {
    font-size: var(--fs-20);
    margin-bottom: 20px;
  }
}
</style>
